import { Component, HostBinding, Input, ViewChild } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { IonContent, RefresherCustomEvent } from '@ionic/angular'
import { NavMeta, TipKey, tipFor } from 'src/app/domain/screens'
import { ShellService } from 'src/app/services/shell.service'

/** The outermost element of every signed-in page: scroll container, pull-to-refresh, the route's tip strip,
 *  the page body and an optional sticky footer (`<x rtPageFooter>`). Pages never write ion-content themselves. */
@Component({
  selector: 'rt-page',
  templateUrl: './rt-page.component.html',
})
export class RtPageComponent {
  @Input() bg: 'grey' | 'paper' | 'white' = 'grey'
  @Input() refresh = true
  @ViewChild(IonContent, { static: true }) private content: IonContent

  readonly tip: TipKey | null

  @HostBinding('class') get hostClass() {
    return `rt-page--${this.bg}`
  }

  constructor(route: ActivatedRoute, private shell: ShellService) {
    const snap = route.snapshot
    const meta = snap.data['nav'] as NavMeta | undefined
    this.tip = meta ? tipFor(meta, snap) : null
  }

  scrollToTop(): Promise<void> {
    return this.content.scrollToTop(300)
  }

  async pull(e: Event) {
    try {
      await this.shell.refresh()
    } finally {
      await (e as RefresherCustomEvent).target.complete()
    }
  }
}
